// Portfolio request functions (the centralized service layer; FRONTEND_RULES §9).
// Pure async functions over the shared client — no Redux, no React. The slice
// thunk composes them.

import { apiGet } from './client';

/**
 * GET /portfolio?accountId= — the full portfolio payload for one account: funds,
 * holdings, asset classes, money sources, fund fact sheets, performance series,
 * sparklines and activity.
 * @param {string} accountId e.g. "ACC-P001-ACME"
 */
export function getPortfolio(accountId) {
  return apiGet(`/portfolio?accountId=${encodeURIComponent(accountId)}`);
}
